"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var makeStyles_1 = require("@material-ui/core/styles/makeStyles");
var tooltipStyles = makeStyles_1.default(function (theme) { return ({
    tooltipIconButton: {
        padding: '2px 0 10px 2px',
    },
    tooltipSvg: {
        width: '20px',
        height: '20px',
    },
    tooltipArrow: {
        fontSize: 16,
        width: 17,
        '&:before': {
            border: "1px solid " + theme.palette.primary.main,
            backgroundColor: theme.palette.common.white,
            boxSizing: 'border-box',
        },
        '&:after': {
            display: 'none',
        },
    },
    tooltipContainer: {
        position: 'relative',
        borderRadius: 10,
        fontSize: theme.typography.fontXS,
        background: theme.palette.common.white,
        color: theme.palette.common.black,
        border: "1px solid " + theme.palette.primary.main,
        margin: 0,
        padding: '15px 30px 20px 15px',
        boxShadow: '0px 2px 5px rgba(0,0,50,0.2)',
        whiteSpace: 'pre-wrap',
    },
}); }, { name: 'Summary_Tooltip' });
exports.default = tooltipStyles;
